<div class="clearfix"></div>
<nav aria-label="...">
  <div style="display: inline-flex; width: 100%; position: relative;">
    <mat-form-field style="max-width: 90px">
      <mat-select (selectionChange)="changeLimit()" placeholder="Showing" name="showing" [(ngModel)]="items_per_page"
        ariaLabel="itemsPerPageSelected">
        <mat-option value="5">5</mat-option>
        <mat-option value="10">10</mat-option>
        <mat-option value="25">25</mat-option>
        <mat-option value="50">50</mat-option>
        <mat-option value="100">100</mat-option>
        <mat-option value="200">200</mat-option>
        <mat-option value="500">500</mat-option>
        <mat-option value="1000">1000</mat-option>
        <mat-option value="ALL">ALL</mat-option>
      </mat-select>
    </mat-form-field>
    <p style="align-self: flex-end; margin-left: 30%;">
      Showing {{this.showingNav}} to {{this.showingTo < total_items_count ? showingTo : total_items_count}} of {{total_items_count}} entries
    </p>

    <ul class="pagination" style="position: absolute; right: 0;">
      <div style="display: flex;">
        <li class="page-item">
          <a (click)="goToPage(1)" *ngIf="page_actual > 1" class="page-link" tabindex="-1">First</a>
        </li>
        <li class="page-item">
          <a (click)="goToPage(page_actual - 1)" *ngIf="page_actual > 1" class="page-link" tabindex="-1">Previous</a>
        </li>
        <li *ngFor="let page of pages" class="page-item">
          <a [className]="page_actual == page+1 ? 'selected-page' : 'page-link'"
            (click)="goToPage(page+1)">{{page+1}}</a>
        </li>
        <li class="page-item">
          <a class="page-link" *ngIf="page_actual < total_pages" (click)="goToPage(page_actual + 1)">Next</a>
        </li>
        <li class="page-item">
          <a (click)="goToPage(total_pages)" *ngIf="page_actual < total_pages" class="page-link" tabindex="-1">Last</a>
        </li>
      </div>
    </ul>
  </div>
</nav>
